import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/CatalogFields.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/catalog-management/catalogs/fields`;
	}
	getFieldValues(e) {
		return this.api.post(`${n.baseUrl}/values`, e);
	}
};
export { n as CatalogFields };

//# sourceMappingURL=CatalogFields.js.map